import moment from "moment";
import { useEffect, useState } from "react";
import { useApiOperation } from "src/api/hooks";
import { PageMeta } from "src/api/public-types";
import { BaseTooltip } from "src/components";
import BaseSelectTable from "src/components/BaseSelectTable";
import { PagePath } from "src/pages/product/details";

import { getContractApply } from "src/api/contract/contract-api";
import { ContractManageList } from "src/api/contract/contract-types";
import { ViewYmdFormat } from "src/utils";
import { BaseContractStatus } from "../BaseContractStatus";
import BaseNewTabLink from "../BaseNewTabLink";

const columns: any = [
  {
    // 기존 "id" 컬럼 대체. 링크 대상이 프로바이더 상세로 잘못 연결돼 있어 신청/계약 상세로 교정했다.
    Header: "계약 ID",
    accessor: "contractId",
    width: 80,
    Cell: ({ value }: { value?: string }) => {
      if (!value) {
        return "-";
      }
      return <BaseNewTabLink path={PagePath.contract.detail.replace(":id", value)} value={value} className="ml16" />;
    },
  },

  {
    Header: "상태",
    accessor: "contractStep",
    width: 80,
    Cell: ({ value }: any) => {
      return <BaseContractStatus status={value} />;
    },
  },
  {
    Header: "계약명",
    accessor: "contractName",
    width: 220,
    // 계약명(선택)이 비어있는 계약이 많아 레포 관례대로 상품명으로 폴백한다
    Cell: ({ value, row }: any) => {
      return (
        <div className="w-100 text-left">
          <BaseTooltip contents={value || row?.original?.spaceProductName || "-"} />
        </div>
      );
    },
  },
  {
    Header: "법인명/상호",
    accessor: "mbOrganizationName",
    width: 130,
    sticky: "left",
    Cell: ({ value }: any) => {
      return <div className="w-100 text-left">{value ? <BaseTooltip contents={value} /> : "-"}</div>;
    },
  },
  {
    Header: "계약자명",
    accessor: "contractorName",
    width: 130,
    sticky: "left",
    Cell: ({ value }: any) => {
      return <div className="w-100 text-left">{value ? <BaseTooltip contents={value} /> : "-"}</div>;
    },
  },
  {
    Header: "이용시작일시",
    accessor: "contractStartTime",
    width: 120,
    Cell: ({ value }: any) => {
      return <>{value ? moment(value).format(ViewYmdFormat.YYYY_MM_DD) : "-"}</>;
    },
  },
  {
    Header: "이용종료일시",
    accessor: "contractEndTime",
    width: 145,
    Cell: ({ value }: any) => {
      return <>{value ? moment(value).format(ViewYmdFormat.YYYY_MM_DD) : "-"}</>;
    },
  },
];
type Props = {
  onClick?: (data: ContractManageList[]) => void;
  onClose?: () => void;
  defaultCheckedList?: string[];
  customColumns?: any[];
  checkboxType?: "checkbox" | "radio";
};

const SelectContractPopup = ({ onClick, onClose, defaultCheckedList, customColumns, checkboxType }: Props) => {
  const [contracts, setContracts] = useState<Array<ContractManageList>>([]);
  const [defaultDisabledList, setDefaultDisabledList] = useState<string[]>();
  const [pageMeta, setPageMeta] = useState<PageMeta>();

  const { executeAsync: getContractList } = useApiOperation(getContractApply);

  const [params, setParams] = useState({
    page: 0,
    size: 20,
    searchType: "All",
    searchValue: "",
    sort: {
      orders: [
        {
          property: "contractManageId",
          direction: "DESC",
        },
      ],
    },
  });

  useEffect(() => {
    const fetchApi = async () => {
      const contractListRes = await getContractList(params);
      // 다른 CS 에서 사용 중인 신청계약ID 비활성화 해제 v1.21

      // console.log("contractListRes.data.data.data :>> ", contractListRes.data.data.content);

      setContracts(contractListRes?.data?.data?.content);
      setPageMeta(contractListRes?.data?.meta?.pageMeta);
    };

    fetchApi();
  }, [params]);

  return (
    <BaseSelectTable
      setParams={setParams}
      defaultDisabledList={defaultDisabledList}
      defaultCheckedList={defaultCheckedList}
      title="신청/계약 선택"
      selectKey={"contractId"}
      columns={customColumns ? customColumns : columns}
      data={contracts.map((data) => ({ ...data, contractId: String(data.contractId) })) ?? []}
      checkboxType={checkboxType ?? "radio"}
      onClick={(_, checkedObjList) => onClick && onClick(checkedObjList.map((data) => ({ ...data, contractId: +data.contractId })))}
      onClose={() => onClose && onClose()}
      pageMeta={pageMeta}
      searchInputProps={{
        searchOptionList: [
          { value: "ALL", label: "전체" },
          { value: "CONTRACT_ID", label: "ID" },
          { value: "APPLICANT_CORPORATION", label: "법인명/상호" },
          { value: "SPACE_PRODUCT_NAME", label: "상품명" },
          { value: "CONTRACTOR_NAME", label: "계약자명" },
        ],

        onSearch(searchKeyword, searchOption) {
          setParams((prev) => ({ ...prev, page: 0, searchValue: searchKeyword, searchType: searchOption }));
        },
      }}
    />
  );
};

export default SelectContractPopup;
